import createReactComponent from '../createReactComponent';
var Sigma = createReactComponent('Sigma', [['path', {
  d: 'M18 7V4H6l6 8-6 8h12v-3',
  key: 'zis8ev'
}]]);
export default Sigma;